<template>
  <el-select v-if="showPageLimiter" v-model="limit" :title="$i18n.t('limitation_selector')">
    <el-option v-for="option in [10, 25, 50]" :value="option" :label="limitOption(option)" :key="option">
      {{ limitOption(option) }}
    </el-option>
  </el-select>
</template>

<script>
import pagination from '../../utils/mixin-pagination'
import localStore from '../../utils/mixin-local-store'

/**
 * @param Limitation
 *
 * @description A listákban megjelenő rekordok oldalankénti számát vezérli
 */
export default {
  name: 'Limitation',
  mixins: [pagination, localStore],
  computed: {
    isSqlSelect() {
      return this.$get('isSqlChosen')
    },
    pageSize() {
      return this.$get('pageSize')
    },
    panelId() {
      return this.$get('panelId')
    },
    showPageLimiter() {
      const showPageLimiter = this.$get('visibilityState')({ key: 'showPageLimiter' })
      if (this.isSqlSelect) {
        return showPageLimiter
      }
      return !this.hasPageSize && showPageLimiter
    },
  },
}
</script>
